  <!-- Modal -->
  <div class="modal fade" id="mdlEmailConfiguration" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form [formGroup]="emailForm" (ngSubmit)="addEmail()">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">ID: {{selectedData?.id}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- input fields -->
            <div class="row">
              <div class="col-md-5 pr-1">
                <div class="form-group">
                  <label>Email:</label>
                  <input type="email" [ngClass]="{'is-invalid': emailForm.get('FromEmail').errors && emailForm.get('FromEmail').touched}" 
                    name="FromEmail" formControlName="FromEmail" class="form-control" placeholder="Sender Email...">
                </div>
              </div>
              <div class="col-md-5 pl-1">
                <div class="form-group">
                  <label>Smpt Server:</label>
                  <input type="text" [ngClass]="{'is-invalid': emailForm.get('smtpServer').errors && emailForm.get('smtpServer').touched}"  
                    name="smtpServer" formControlName="smtpServer" class="form-control" placeholder="" value="">
                </div>
              </div>
              <div class="col-md-2 pl-1">
                <div class="form-group">
                  <label>Port</label>
                  <input type="number" [ngClass]="{'is-invalid': emailForm.get('Port').errors && emailForm.get('Port').touched}" 
                    name="Port" formControlName="Port" class="form-control" placeholder="" value="">
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 pr-1">
                <div class="form-group">
                  <label>Password:</label>
                  <input type="password" [ngClass]="{'is-invalid': emailForm.get('PasswordEmail').errors && emailForm.get('PasswordEmail').touched}"
                    name="PasswordEmail" formControlName="PasswordEmail" class="form-control" placeholder="">
                </div>
              </div>
              <div class="col-md-6 pl-1">
                <div class="form-group">
                  <label>Confirm Password:</label>
                  <input type="password" [ngClass]="{'is-invalid': emailForm.get('confirmPassword').errors && emailForm.get('confirmPassword').touched}" 
                    name="confirmPassword" formControlName="confirmPassword" class="form-control" placeholder="" value="">
                </div>
              </div>
            </div>
          <!-- end input fields-->
        </div>
        <div class="modal-footer">
          <button type="button" #closeBtn class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" [disabled]="!emailForm.valid" class="btn btn-primary">
            <span *ngIf="isSaving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="ml-1">Save changes</span>
          </button>
        </div>
        </form>
      </div>
    </div>
  </div>
